export default "__VITE_ASSET__Dix27nvR__"